function insertPlaceholder(element) {
  const placeholder = document.createElement("div");
  placeholder.id = "skip-to";
  element.insertAdjacentElement("afterend", placeholder);
  return placeholder;
}

function skipTo() {
  const main = document.getElementById("main");
  if (main) {
    for (const el of main.children) {
      if (el.querySelector(".c-breadcrumb")) {
        insertPlaceholder(el);
        return;
      }
    }
  }

  const incidentBanner = document.querySelector(".c-incident-banner");
  if (incidentBanner) {
    insertPlaceholder(incidentBanner);
    return;
  }

  const placeholder = document.createElement("div");
  placeholder.id = "skip-to";
  if (main) {
    main.insertBefore(placeholder, main.firstChild);
  }
}

const init = () => {
  skipTo();
}

export default init;


// WEBPACK FOOTER //
// ./src/components/components/consumer/_accessmenu/accessmenu.js